import * as React from "react";
import {connect} from "react-redux";
import StyleComponent from "../components/StyleComponent";
import {loadingStyleSelector, styleCommentsSelector} from "../selectors";
import Meta from "../../_data/models/Meta";
import {fetchCommentsByStyle} from "../../comment/middlewares";
import {styleByIdSelector} from "../../_data/selectors";

const mapStateToProps = (state, props) => {

    const style = styleByIdSelector(state, parseInt(props.match.params.id));
    
    let notFound: boolean = false;
    if(style && style.user.name != props.match.params.username) {
       notFound = true;
    }

    return {
        style: style,
        loading: loadingStyleSelector(state),
        comments: styleCommentsSelector(state),
        notFoundStyle: notFound
    }
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        dispatch: dispatch,
        loadMoreComments: (meta: Meta) => {
            dispatch((dispatch, getState) => {
                const style = styleByIdSelector(getState(), parseInt(props.match.params.id));
                if (style != null) {
                    if (!meta) {
                        dispatch(fetchCommentsByStyle(style.id, 1));
                    } else if (meta && meta.hasNext()) {
                        dispatch(fetchCommentsByStyle(style.id, meta.nextPage));
                    }
                }
            });
        }
    }
};

const StyleContainer = connect(mapStateToProps, mapDispatchToProps)(StyleComponent);
export default StyleContainer;


// WEBPACK FOOTER //
// ./app/client/style/containers/StyleContainer.tsx